module.exports = __webpack_public_path__ + "media/src/images/site-top/mv-startin-6319508005cab49c0cd8b8bdc61b3bde.png";